import { Component, Input, Output } from '@angular/core';
import { AppState } from '../../../../app.service';
import { Service } from './restore-points.service';
import { getDatatableConfig } from './restore-points.dt.config';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { constructInnerTableRestorePoints } from '../../dataprotection-common/common-renderers';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { Modal } from '@clr/angular';
var $ = require('jquery');

@Component({
  selector: 'restore-points',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./restore-points.scss')],
  template: require('./restore-points.html')
})

export class RestorePoints {
  @Input('isVisible') isVisible: boolean;
  @Input('mode') mode: string;
  @Input('selectedObject') selectedObject;
  @Input('selectedVDC') selectedVDC;

  tableData:any = [];
  private subscribeHandler;

  private tableSettings : Object = {};
  private tableConfig : Object = {};
  private currentSelection;
  private restorePointForUpdation;
  private isRowSelected: boolean = false;
  private isTranslationready:boolean = true;
  private innerTableFunction:any = constructInnerTableRestorePoints;
  private classForExpiryClick:Array<string> = ['.expiry-action'];
  private isExpiryDateListeningEnabled: boolean = true;
  private isDeleteRestorePopupVisible: boolean = false;
  private isRefreshRestorePopupVisible: boolean = false;
  private isInPlaceRestorePopupVisible: boolean = false;
  private isOutOfPlaceRestorePopupVisible: boolean = false;
  private isUpdateRestorePopupVisible: boolean = false;
  private isDeletedVappMode:boolean = false;
  private showGridLoadingScreen: boolean = false;
  private defaultSortColumn: number = 2;
  private defaultSortOrder: string = "desc";

  constructor(public appState: AppState, public service: Service, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  ngOnInit() {
    this.tableConfig = getDatatableConfig(this.translate);
    Object.assign(this.tableSettings, this.tableConfig, {"data": []});
  }

  ngOnChanges(changes) {
    /** Defer the REST call to fetch data, until the component is visible (else too many REST calls while loading).
     * This also helps in fixing the bug 'column headers are misaligned'
     * */
    if (changes && changes.hasOwnProperty('isVisible') && changes.isVisible && changes.isVisible.hasOwnProperty('currentValue') && changes.isVisible.currentValue
        && this.selectedObject && this.selectedObject.id) {
          this.getRestorePoints();
    }
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if(this.subscribeHandler) {
      this.subscribeHandler.unsubscribe();
    }
  }

  onGridSelectionChange(event) {
    if (event && event.value && event.value instanceof Array && event.value.length > 0) {
      this.currentSelection = event.value[0];
        this.isRowSelected = true;
    } else {
      this.isRowSelected = false;
    }
  }

  onInPlaceRestore(event) {
    this.isInPlaceRestorePopupVisible = true;
  }

  onDeleteRestore(event) {
    this.isDeleteRestorePopupVisible = true;
  }

  onRefreshRestore(event) {
    this.isRefreshRestorePopupVisible = true;
  }

  onOutOfPlaceRestore(event) {
    this.isOutOfPlaceRestorePopupVisible = true;
  }

  onDeleteRestoreClose(event) {
    if (event && event.value) {
      this.isDeleteRestorePopupVisible = false;
      this.getRestorePoints();
    }
  }

  onRefreshRestoreClose(event) {
    if (event && event.value) {
      this.isRefreshRestorePopupVisible = false;
      this.getRestorePoints();
    }
  }

  onInPlaceRestoreClose(event) {
    if (event && event.value) {
      this.isInPlaceRestorePopupVisible = false;
      this.getRestorePoints();
    }
  }

  onOutPlaceRestoreClose(event) {
    if (event && event.value) {
      this.isOutOfPlaceRestorePopupVisible = false;
      this.getRestorePoints();
    }
  }

  onUpdateRestoreClose(event) {
    if (event && event.value) {
      this.isUpdateRestorePopupVisible = false;
      this.getRestorePoints();
    }
  }

  onChangeExpiryDateClick(event) {
    if (event && event.rowData ) {
      this.restorePointForUpdation = event.rowData;
      this.isUpdateRestorePopupVisible = true;
    }
  }

  getRestorePoints() {
    var vdcIdForDeletedVapp;
    if (this.mode && this.selectedObject && this.selectedObject.id
        && ( (this.selectedVDC && this.selectedVDC.id) || (this.selectedObject.properties && this.selectedObject.properties.vdcId ) )) {
      switch (this.mode) {
        case DataProtectionVariables.RESTORE_MODES['VAPP']:
          this.isDeletedVappMode = false;
          this.getRestorePointsForVapp(this.selectedVDC.id, this.selectedObject.id);
          break;
        case DataProtectionVariables.RESTORE_MODES['DELETED_VAPP']:
          this.isDeletedVappMode = true;
          vdcIdForDeletedVapp = (this.selectedVDC && this.selectedVDC.id) ? this.selectedVDC.id : this.selectedObject.properties.vdcId;
          this.getRestorePointsForDeletedVapp(vdcIdForDeletedVapp, this.selectedObject.id);
          break;
        default :
          this.getRestorePointsForVapp(this.selectedVDC.id, this.selectedObject.id);
      }
    }
    else
      console.error('Error while fetching restore points. Invalid VDC or vApp info ');
  }

  getRestorePointsForVapp(vdcId, vappId) {
    this.showGridLoadingScreen = true;
    this.subscribeHandler = this.service.getRestorePointsForVapp(vdcId, vappId)
      .subscribe(
        tableData => {
          this.tableData = tableData;
        },
        error => this.logError(error, 'get restore points for vapp'),
        () => this.logOperationCompleted('get restore points for vapp')
      );
  }

  getRestorePointsForDeletedVapp(vdcId, vappId) {
    this.showGridLoadingScreen = true;
    this.subscribeHandler = this.service.getRestorePointsForDeletedVapp(vdcId, vappId)
      .subscribe(
        tableData => {
          this.tableData = tableData;
        },
        error => this.logError(error, 'get restore points for deleted vapp'),
        () => this.logOperationCompleted('get restore points for deleted vapp')
      );
  }


  logError(error, origin:String = '') {
    this.showGridLoadingScreen = false;
    console.error('Error: ', error, (origin !== '')? " Error from " + origin : "");
  }

  logOperationCompleted(msg: string) {
    //console.log('Operation Completed: ', msg)
    this.showGridLoadingScreen = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/restore-points/restore-points.component.ts